module.exports = __webpack_public_path__ + "static/img/baas_product_1.00949f3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_product_1.svg
// module id = JRUX
// module chunks = 0